import { ReactNode, createContext, useContext } from 'react';
import { NotificationDto } from 'src/generated/services/TFinancialApi';

export interface INotificationSelectorProps {
  children: ReactNode;
}

export interface INotificationContext {
  // UI State
  isShowContent: boolean;
  isShowDetail: boolean;
  selectedDetail: NotificationDto;

  // Filter State
  dateFilter: string;

  // Actions
  setIsShowContent: (status: boolean) => void;
  setIsShowDetail: (status: boolean) => void;
  setSelectedDetail: (data: NotificationDto) => void;
  setDateFilter: (date: string) => void;

  // Combined Actions
  onShowDetail: (notification: NotificationDto) => void;
  onHideDetail: () => void;
  onResetState: () => void;
}

export const NotificationSelectorContext = createContext<INotificationContext>(null);

// eslint-disable-next-line react-refresh/only-export-components
export function useNotificationSelector() {
  const context = useContext(NotificationSelectorContext);

  if (!context) {
    throw new Error(`Notification components cannot be rendered outside the NotificationSelector component`);
  }
  return context;
}
